import { render, staticRenderFns } from "./SafeInv.vue?vue&type=template&id=5e83a9b6&scoped=true&"
import script from "./SafeInv.vue?vue&type=script&lang=js&"
export * from "./SafeInv.vue?vue&type=script&lang=js&"
import style0 from "./SafeInv.vue?vue&type=style&index=0&id=5e83a9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83a9b6",
  null
  
)

export default component.exports